import React from 'react';

interface SettingsHeaderProps {
  isSaving: boolean;
}

export function SettingsHeader({ isSaving }: SettingsHeaderProps) {
  return (
    <section className="flex flex-col gap-3 rounded-md bg-transparent pb-2 border-b border-slate-200 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-emerald-50 text-emerald-600 border border-emerald-100">
          <i className="ri-settings-3-line text-xl" />
        </div>
        <div className="space-y-0.5">
          <h1 className="text-base sm:text-lg font-medium leading-tight text-slate-900">Cài đặt hệ thống</h1>
          <p className="text-xs text-slate-500">Quản lý cấu hình và phân quyền toàn hệ thống</p>
        </div>
      </div>
      {isSaving ? <span className="text-xs font-medium text-emerald-600 flex items-center gap-1"><i className="ri-loader-4-line animate-spin" /> Đang lưu...</span> : null}
    </section>
  );
}
